import React from 'react'
import appPerson_initial_state from './appPerson_initial_state'
export default React.createContext(appPerson_initial_state)
